import React from 'react'
import { PassoAPassoWrapper } from '../style'
import Stepper from './Stepper'
import { CustomButton } from 'styles/global'
import { Col, Row } from 'reactstrap'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const PassoAPasso = () => {
  return (
    <PassoAPassoWrapper className="container">
      <div>
        <h3 className="title">
          É fácil e rápido contratar
          <br /> nossos empréstimos.
        </h3>
        <label className="subtitle">
          Tudo 100% online, sem complicação e em poucos minutos.
        </label>
      </div>
      <div className="d-flex justify-content-center">
        <Stepper steps={3} className="d-none d-md-flex stepper-small" />
      </div>
      <div>
        <Row className="d-flex align-items-stretch justify-content-between row-gap-20 mb-5">
          <Col md={4} className="d-flex justify-content-center">
            <div className="card-passo">
              <img
                className="mb-4"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_9.png"
                width={50}
              />
              <label>Simulação</label>
              <p>
                Informe seus dados e veja as melhores ofertas de crédito para o
                seu perfil. Rápido e sem compromisso.
              </p>
            </div>
          </Col>
          <Col md={4} className="d-flex justify-content-center">
            <div className="card-passo">
              <img
                className="mb-4"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_10.png"
                width={50}
              />
              <label>Contratação</label>
              <p>
                Escolha a proposta ideal, complete seus dados dados com total
                segurança.
              </p>
            </div>
          </Col>
          <Col md={4} className="d-flex justify-content-center">
            <div className="card-passo">
              <img
                className="mb-4"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_11.png"
                width={50}
              />
              <label>Assinatura</label>
              <p>
                Assine digitalmente e receba o valor direto na conta, com
                agilidade e transparência.
              </p>
            </div>
          </Col>
        </Row>
        <HashLink
          to="/#iniciar-simulacao"
          className="w-auto d-flex justify-content-center mx-4 no-styled-link"
          smooth
          scroll={(el) => {
            scrollWithOffset(el, 300)
          }}
        >
          <CustomButton
            className="button-simulation"
            background="var(--verde-riber)"
            onClick={() => {
              //
            }}
          >
            Simular
          </CustomButton>
        </HashLink>
      </div>
    </PassoAPassoWrapper>
  )
}

export default PassoAPasso
